import ReviewSlider from '../../components/reviews/reviewSlider';
export default ReviewSlider;